import api from "../../app-shared/components/utils/http/http-service";

class PageContentService {
    static getCurrent(page) {
        return api.get(`/content?page=${page}`);
    }
}

export default PageContentService;
